<div class="filters-list">
  <div class="filters-sidebar">
    <button type="button" [disabled]="!isLicenseValid" (click)="onAddFilter()" pButton icon="fa fa-plus-square-o" label="New Device Filter" class="add-button"></button>
    <p></p>
    @for (filter of allFilters; track filter) {
      <div class="row list-row">
        <div class="col-10">
          <span class="clickable-filter-item" [class.active]="selectedFilter == filter" (click)="onSelectFilter(filter)">
            <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>{{filter.DeviceFilter.Name}}
          </span>
        </div>
        <div class="col-2">
          <button [disabled]="!isLicenseValid" (click)="onDeleteFilter(filter)" class="btn btn-danger">
            <i class="pi pi-trash"></i>
          </button>
        </div>
      </div>
    }
  </div>

  @if (!!selectedFilter) {
    <div style="order: 2; flex-grow: 1; overflow-x:hidden;">
      <device-filter [target]="selectedFilter" (onApply)="onAppliedChange()"></device-filter>
    </div>
  }

  @if (!selectedFilter) {
    <div
      style="order: 2; flex-grow: 1; text-align: center; padding-top: 50px; padding-bottom: 50px; font-family: 'Roboto', 'Trebuchet MS', Arial, Helvetica, sans-serif; font-size: x-large; overflow-x:hidden;">
      <div>Select a device filter to view/edit its details, or</div>
      <div>Click &quot;New Device Filter&quot; to create a new device filter</div>
    </div>
  }

  <p-dialog [(visible)]="showTempChangesDialog">
    <p-header>
      <span>Unapplied Changes</span>
    </p-header>
    <p>Your changes have not been applied, and will be lost if you continue.</p>
    @if (showTempChangesDialog && !applyTempChangesEnabled) {
      <p>
        Some of the changes are currently invalid and cannot be applied.
      </p>
    }
    <p>Select one of the options below.</p>
    <p-footer>
      @if (showTempChangesDialog && applyTempChangesEnabled) {
        <button type="button" pButton [disabled]="!isLicenseValid"
        (click)="onApplyTempChanges()" label="Apply Changes"></button>
      }
      <button type="button" pButton (click)="onDiscardTempChanges()" label="Discard Changes"></button>
      <button type="button" pButton (click)="onCancelNavigation()" label="Cancel"></button>
    </p-footer>
  </p-dialog>

</div>
